import { useState } from "react";
import { CommonMainWrap, ListDetailTemplate } from "../../styles/common"
import Cars from "./Cars";
import CarsClassDetail from './CarsClassDetail';

const CarsClass = () => {

    const [target, setTarget] = useState();

    return (
        <CommonMainWrap>
            <ListDetailTemplate>
                <CarsClassDetail  onClick={setTarget}/>
                <div className="detail">
                    <Cars ccid={target && target.ccid} />
                </div>
            </ListDetailTemplate>
        </CommonMainWrap>
    )
}

export default CarsClass;